import { render, staticRenderFns } from "./AdminAddproduct.vue?vue&type=template&id=02c3f14c"
import script from "./AdminAddproduct.vue?vue&type=script&lang=js"
export * from "./AdminAddproduct.vue?vue&type=script&lang=js"
import style0 from "./AdminAddproduct.vue?vue&type=style&index=0&id=02c3f14c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports